import {
  createSlice,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';
import { getEncodedURL } from '../../../utils/utils';

const URL =
  'payment-options-proxy?endpoint=paymentdashboard/legacy/config-module';

function convertUnderscoreToSlash(str) {
  return str.replace(/_/g, '/');
}

export const getLegacyConfigModuleById = createAsyncThunk(
  'getLegacyConfigModuleById',
  async (path, { rejectWithValue }) => {
    try {
      const url = getEncodedURL(
        `${URL}?filePath=${convertUnderscoreToSlash(path)}`,
      );
      console.log({ url });

      const { data, status } = await apiConfig.get(url);

      if (status !== 200) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateLegacyConfigModuleById = createAsyncThunk(
  'updateLegacyConfigModuleById',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const url = `${URL}`;
      const { data, status } = await apiConfig.post(url, payload);

      if (status !== 200) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const rollBackLegacyConfigModuleByFilename = createAsyncThunk(
  'rollBackLegacyConfigModuleByFilename',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const url = `${URL}/rollback`;
      const { data, status } = await apiConfig.post(url, payload);

      if (status !== 200) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const SLICE_NAME = 'legacyPaymentOptionsContextualMessages';

const initialState = {
  selectedConfigModule: null,
  selectedLastModifiedBy: '',
};

const legacyPaymentOptionsContextualMessages = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLegacyConfigModuleById.pending, (state) => {
        state.selectedConfigModule = null;
      })
      .addCase(getLegacyConfigModuleById.rejected, (state) => {
        state.selectedConfigModule = null;
      })
      .addCase(getLegacyConfigModuleById.fulfilled, (state, { payload }) => {
        if (payload && payload.status === 'SUCCESS') {
          state.selectedConfigModule = payload.data;
          state.selectedLastModifiedBy = payload.modifiedBy;
        }
      });
  },
});

export const selectSelectedConfigModule = (state) =>
  state.legacyPaymentOption.legacyConfigurationModule.selectedConfigModule;

export const selectSelectedLastModifiedBy = (state) =>
  state.legacyPaymentOption.legacyConfigurationModule.selectedLastModifiedBy;

export const legacyPaymentOptionsContextualMessageActions =
  legacyPaymentOptionsContextualMessages.actions;

export default legacyPaymentOptionsContextualMessages.reducer;
